// extracted by mini-css-extract-plugin
export default {"hrow":"hrow--oZJ0Y","row":"row--oZJ0Y","cell":"cell--oZJ0Y","col":"col--oZJ0Y","mobileTable":"mobileTable--oZJ0Y","singleColumn":"singleColumn--oZJ0Y"};